import { render, staticRenderFns } from "./China.vue?vue&type=template&id=2457bda9&"
import script from "./China.vue?vue&type=script&lang=js&"
export * from "./China.vue?vue&type=script&lang=js&"
import style0 from "./China.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports